import React, { useCallback, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import parse from "html-react-parser";
import { Modal } from "antd";

import { put } from "../../../modules/httpFunctions";
import { handleError } from "../../../modules/errorLogger";

const Detail = ({
  language,
  notification,
  notifications,
  onSetNotifications,
}) => {
  const intl = useIntl();
  const markAsRead = useCallback(
    (read = true) => {
      onSetNotifications([
        ...notifications.filter((n) => n.id !== notification.id),
        { ...notification, read: read, cancel: !read },
      ]);
    },
    [notification, notifications, onSetNotifications]
  );

  const [loading, setLoading] = useState();
  const handleOk = useCallback(() => {
    setLoading(true);
    put(`notification/${notification.id}/read`)
      .then(() => {
        setLoading(false);
        markAsRead();
      })
      .catch((err) => {
        setLoading(false);
        handleError(err);
        markAsRead();
      });
  }, [markAsRead, notification]);

  const handleCancel = useCallback(() => {
    markAsRead(false);
  }, [markAsRead]);

  return notification ? (
    <Modal
      visible
      onOk={handleOk}
      closable={false}
      onCancel={handleCancel}
      confirmLoading={loading}
      title={
        language.iso6391Code === "cs"
          ? notification.title
          : language.iso6391Code === "pl"
          ? notification.titlePl
          : notification.titleEn
      }
      okText={intl.formatMessage({
        id: "notification.confirm",
        defaultMessage: "Potvrzuji přečtení",
      })}
      cancelText={
        <FormattedMessage
          id="notification.later"
          defaultMessage="Přečíst později"
        />
      }
    >
      {parse(
        language.iso6391Code === "cs"
          ? notification.message
          : language.iso6391Code === "pl"
          ? notification.messagePl
          : notification.messageEn
      )}
    </Modal>
  ) : (
    <></>
  );
};

export default Detail;
